import {SearchList} from '../../models/search-list.model';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {FormState} from '../../models/form-state.model';
import {Injectable} from '@angular/core';
import {PolicyService} from '../../services/policy.service';
import {handleFetchListPage} from '../../helpers/search.helper';
import {PolicyRegistryActions} from './policy-registry.actions';
import {PolicyIdentity} from '../../models/policy.model';
import {SearchOrder} from '../../enums/search-order.enum';

interface PolicyRegistryStateModel {
    list: SearchList<PolicyIdentity>;
}

const createSearchList = () => new SearchList<PolicyIdentity>({
    filters: new FormState(),
    orderByField: 'number',
    orderDirection: SearchOrder.DESC,
});

@State<PolicyRegistryStateModel>({
    name: PolicyRegistryState.STATE_NAME,
    defaults: {
        list: createSearchList()
    }
})

@Injectable()
export class PolicyRegistryState {
    static readonly STATE_NAME = 'policyRegistry';

    constructor(
        private policyService: PolicyService,
    ) {
    }

    @Selector()
    static policyRegistryList(state) {
        return state.list;
    }

    @Action(PolicyRegistryActions.GetListPage)
    getListPage(ctx: StateContext<PolicyRegistryStateModel>, action: PolicyRegistryActions.GetListPage) {
        return handleFetchListPage(ctx, action.params, (props) => this.policyService.fetchList(props));
    }

    @Action(PolicyRegistryActions.ClearListItems)
    clearListItems(ctx: StateContext<PolicyRegistryStateModel>) {
        const {list} = ctx.getState();
        ctx.patchState({
            list: {
                ...list,
                items: null
            }
        });
    }

    @Action(PolicyRegistryActions.ClearList)
    clearList(ctx: StateContext<PolicyRegistryStateModel>) {
        ctx.patchState({
            list: createSearchList()
        });
    }
}
